<template>
    <div>
        <validation-provider #default="{ errors }" name="name" rules="required">
            <b-form-group
                id="fieldset-name"
                :description="$t('settings.teams.name.description')"
                :label="`${$t('settings.teams.name.label')}*`"
                content-cols-lg="7"
                content-cols-sm
                label-cols-lg="3"
                label-cols-sm="4"
                label-for="name"
            >
                <b-form-input
                    id="name"
                    v-model="teamData.name"
                    :state="errors.length > 1 ? false : null"
                    name="name"
                    required
                />
                <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
        </validation-provider>
        <validation-provider #default="{ errors }" name="email" rules="email">
            <b-form-group
                id="fieldset-email"
                :description="$t('settings.teams.email.description')"
                :label="$t('settings.teams.email.label')"
                content-cols-lg="7"
                content-cols-sm
                label-cols-lg="3"
                label-cols-sm="4"
                label-for="email"
            >
                <b-form-input
                    id="email"
                    v-model="teamData.email"
                    :state="!errors || errors.length < 1 ? null : false"
                    name="email"
                />
                <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
        </validation-provider>
        <b-form-group
            id="fieldset-color"
            :description="$t('settings.teams.color.description')"
            :label="$t('settings.teams.color.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="name"
        >
            <b-form-input id="color" v-model="teamData.color" name="color" type="color" />
        </b-form-group>
        <b-form-group
            id="fieldset-send-notification"
            :description="$t('settings.teams.send-notification.description')"
            :label="$t('settings.teams.send-notification.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="sendNotification"
        >
            <b-form-checkbox
                v-model="teamData.sendNotificationOnNewConversation"
                inline
                name="sendNotification"
                switch
                unchecked-value="0"
                value="1"
            />
        </b-form-group>
    </div>
</template>
<script>
import { BCard, BButton, BFormInput, BContainer, BRow, BFormCheckbox, BFormGroup } from "bootstrap-vue";
import { ValidationProvider } from "vee-validate";
import { required } from "@validations";

export default {
    components: {
        BCard,
        BButton,
        BFormInput,
        BContainer,
        BRow,
        BFormCheckbox,
        BFormGroup,
        ValidationProvider,
    },
    props: {
        teamData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            required,
        };
    },
};
</script>
